import React from "react";
import NavMenu from "../NavMenu";
import AIChatBox from "./AIChatBox";

export default function RIAPage() {
  return (
    <div>
      <NavMenu />
      <div style={{ display: "flex", justifyContent: "center", padding: "20px 16px" }}>
        <div style={{ width: "100%", maxWidth: 900 }}>
          <AIChatBox />
        </div>
      </div>
    </div>
  );
}
